import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className="p-2 rounded-full bg-neutral-light dark:bg-dark-accent text-text-primary dark:text-dark-text transition-all duration-200 flex items-center justify-center hover-glow-sm"
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? (
      <FiSun className="w-5 h-5" />
      ) : (
      <FiMoon className="w-5 h-5" />
      )}
    </button>
  );
};

export default ThemeToggle;